if (!customElements.get("el-organs-problems")) {
  customElements.define(
    "el-organs-problems",
    class ElOrgansProblems extends HTMLElement {
      constructor() {
        super();
        this.hasAnimatedStats = false;
      }

      connectedCallback() {
        this.triggers = Array.from(
          this.querySelectorAll("[data-organs-trigger]"),
        );
        this.panels = Array.from(this.querySelectorAll("[data-organs-panel]"));
        this.percentEl = this.querySelector("[data-organs-percent]");
        this.progressEl = this.querySelector("[data-organs-progress]");
        this.targetPercent = Number(this.dataset.statsPercent || 0);

        this.setupAccordion();
        this.setupStatsAnimation();

        window.addEventListener("resize", this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.handleResize);
      }

      handleResize = () => {
        this.updateActivePanels();
      };

      setupAccordion() {
        this.triggers.forEach((trigger) => {
          trigger.addEventListener("click", () => {
            const item = trigger.closest(".el-organs-problems__item");
            const isActive = item.classList.contains("is-active");

            this.closeAllItems();

            if (!isActive) {
              this.openItem(item);
            }
          });
        });

        this.updateActivePanels();
      }

      closeAllItems() {
        this.querySelectorAll(".el-organs-problems__item").forEach((item) => {
          const trigger = item.querySelector("[data-organs-trigger]");
          const panel = item.querySelector("[data-organs-panel]");

          item.classList.remove("is-active");

          if (trigger) {
            trigger.setAttribute("aria-expanded", "false");
          }

          if (panel) {
            panel.style.maxHeight = "0px";
          }
        });
      }

      openItem(item) {
        const trigger = item.querySelector("[data-organs-trigger]");
        const panel = item.querySelector("[data-organs-panel]");

        item.classList.add("is-active");

        if (trigger) {
          trigger.setAttribute("aria-expanded", "true");
        }

        if (panel) {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        }
      }

      updateActivePanels() {
        this.querySelectorAll(".el-organs-problems__item.is-active").forEach(
          (item) => {
            const panel = item.querySelector("[data-organs-panel]");

            if (panel) {
              panel.style.maxHeight = `${panel.scrollHeight}px`;
            }
          },
        );
      }

      setupStatsAnimation() {
        if (!this.percentEl) return;

        const runAnimation = () => {
          if (this.hasAnimatedStats) return;

          this.hasAnimatedStats = true;
          this.classList.add("is-animated");

          const scale = Math.max(0, Math.min(this.targetPercent, 100)) / 100;
          this.style.setProperty("--progress-scale", scale);

          this.animatePercent();
        };

        if (!("IntersectionObserver" in window)) {
          runAnimation();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                runAnimation();
                observer.disconnect();
              }
            });
          },
          {
            threshold: 0.35,
          },
        );

        observer.observe(this);
      }

      animatePercent() {
        const duration = 1200;
        const startTime = performance.now();
        const target = Math.max(0, Math.min(this.targetPercent, 100));

        const tick = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const value = Math.round(target * eased);

          this.percentEl.textContent = `${value}%`;

          if (progress < 1) {
            requestAnimationFrame(tick);
          } else {
            this.percentEl.textContent = `${target}%`;
          }
        };

        requestAnimationFrame(tick);
      }
    },
  );
}
